import history from 'utils/history';

import { NavigationOptions } from './types';

/**
 * Handles navigation back with optional custom path
 *
 * @param options - Navigation options
 * @param options.goBackPath - Optional custom path to navigate to
 * @returns void
 *
 * @example
 * handleGoBack({ goBackPath: '/dashboard' });
 * handleGoBack(); // Uses browser back
 */
export const handleGoBackNavigation = ({ goBackPath }: NavigationOptions = {}): void => {
  if (goBackPath) {
    history.replace(goBackPath);
    return;
  }

  history.goBack();
};

/**
 * Determines if the layout should show a back button
 *
 * @param hasOnGoBack - Whether onGoBack handler is provided
 * @param hasDefaultGoBack - Whether default go back is enabled
 * @param hasGoBackPath - Whether custom go back path is provided
 * @returns True if back button should be shown
 *
 * @example
 * shouldShowBackButton(true, false, false); // true
 * shouldShowBackButton(false, true, false); // true
 * shouldShowBackButton(false, false, false); // false
 */
export const shouldShowBackButton = (
  hasOnGoBack: boolean,
  hasDefaultGoBack: boolean,
  hasGoBackPath: boolean,
): boolean => {
  return hasOnGoBack || hasDefaultGoBack || hasGoBackPath;
};

/**
 * Determines if the layout should show action buttons
 *
 * @param hasActionComponent - Whether action component is provided
 * @param hasOnAction - Whether onAction handler is provided
 * @returns True if action buttons should be shown
 *
 * @example
 * shouldShowActionButtons(true, false); // true
 * shouldShowActionButtons(false, true); // true
 * shouldShowActionButtons(false, false); // false
 */
export const shouldShowActionButtons = (hasActionComponent: boolean, hasOnAction: boolean): boolean => {
  return hasActionComponent || hasOnAction;
};
